import { Button, Col, Empty, Popover, Radio, Row, Spin, Tooltip } from 'antd';
import moment from 'moment';
import { Fragment, useState } from 'react';
import { useTranslation } from "react-i18next";
import { Link, useLocation } from 'react-router-dom';

const { format } = require('rut.js');

const ConfirmedReservation = ({
  confirmedReservations,
  fetchReservationServices,
  fetchReservationPatients,
  reservationServices,
  reservationPatients,
}) => {
  const [loading, setLoading] = useState(false);
  const location = useLocation()
  const { t } = useTranslation();

  const formatDate = (date) => {
    return moment(date, 'YYYY-MM-DD').format('DD-MM-YYYY');
  };

  const loadMore = (event) => {
    const direction = event.target.value;
    const _currentPage =
      direction === "next"
        ? confirmedReservations.currentPage + 1
        : confirmedReservations.currentPage - 1;
    confirmedReservations.changePage(_currentPage);
  };

  const allPatients = (reservation) => {
    const _totalPatients = parseInt(reservation.total_patients);
    let _admittedPatients = reservation.patients;
    const calcDifference = _totalPatients - _admittedPatients.length;

    for (let i = 0; i < calcDifference; i++) {
      _admittedPatients.push({ full_name: null });
    }

    return _admittedPatients;
  };

  return (
    <Row justify="center">
      {confirmedReservations.data && confirmedReservations.data.length > 0 ? (
        <Fragment>
          <Col
            lg={22}
            xs={22}
            className="confirmed-wrapper mt-lg-50 mt-md-20 mt-sm-20 mt-xs-20 mb-lg-30 mb-md-20 mb-sm-20 mb-xs-20"
          >
            <Row justify="start" className="table-header">
              <Col lg={3}>
                <p className="mb-5 ml-15">
                  {t('reservations.byFilters.confirmedReservationTab.reservationNumber')}
                </p>
              </Col>
              <Col lg={3}>
                <p className="text-center mb-5">
                  {t('reservations.byFilters.confirmedReservationTab.dateTitle')}
                </p>
              </Col>
              <Col lg={4}>
                <p className="text-center mb-5">
                  {t('reservations.byFilters.confirmedReservationTab.companyTitle')}
                </p>
              </Col>
              <Col lg={3}>
                <p className="text-center mb-5">
                  {t('reservations.byFilters.confirmedReservationTab.branchOfficeTitle')}
                </p>
              </Col>
              <Col lg={3}>
                <Popover
                  trigger="hover"
                  overlayClassName="sidebar-tooltip"
                  placement="topLeft"
                  content={
                    <p className="mb-5">
                      {t("reservations.byFilters.confirmedReservationTab.attendancePopover")}
                    </p>
                  }
                >
                  <p className="text-center mb-5">
                    <u>{t("reservations.byFilters.confirmedReservationTab.attendanceTitle")}</u>
                  </p>
                </Popover>
              </Col>
              <Col lg={3}>
                <p className="text-center mb-5">
                  {t('reservations.byFilters.confirmedReservationTab.servicesTitle')}
                </p>
              </Col>
              <Col lg={3}>
                <p className="text-center mb-5">
                  {t('reservations.byFilters.confirmedReservationTab.patientsTitle')}
                </p>
              </Col>
              <Col lg={2}></Col>
            </Row>
            {confirmedReservations?.data?.map((reservation) => {
              return (
                <Row
                  className="table-body mb-lg-10 mb-md-15 mb-sm-15 mb-xs-15"
                  key={reservation.id}
                >
                  <Col lg={3} xs={12} className="table-body__item-confirmed">
                    <p className="mobile-title text-center">
                      {t('reservations.byFilters.confirmedReservationTab.reservationNumber')}
                    </p>
                    <p className="mb-0 ml-lg-15">{reservation.number}</p>
                  </Col>
                  <Col lg={3} xs={12} className="table-body__item-confirmed">
                    <p className="mobile-title text-center">
                      {t('reservations.byFilters.confirmedReservationTab.dateTitle')}
                    </p>
                    <p className="text-center mb-0">
                      {formatDate(reservation.reservation_date)}
                    </p>
                  </Col>
                  <Col lg={4} xs={12} className="table-body__item-confirmed">
                    <p className="mobile-title text-center">
                      {t('reservations.byFilters.confirmedReservationTab.companyTitle')}
                    </p>
                    <p className="text-center mb-0">
                      {reservation?.business_name}
                    </p>
                  </Col>
                  <Col lg={3} xs={12} className="table-body__item-confirmed">
                    <p className="mobile-title text-center">
                      {t('reservations.byFilters.confirmedReservationTab.branchOfficeTitle')}
                    </p>
                    <p className="text-center mb-0">
                      {reservation.branch_office_name}
                    </p>
                  </Col>
                  <Col lg={3} xs={12} className="table-body__item-confirmed">
                    <p className="text-center mb-5">
                      {
                        reservation?.willAttend >= 0 && reservation?.preadmittedPatients >= 0 ?
                          reservation.willAttend + '/' + reservation.preadmittedPatients
                          : "-"
                      }
                    </p>
                  </Col>
                  <Col lg={3} xs={12} className="table-body__item-confirmed">
                    <Tooltip
                      overlayClassName='see-services-tooltip'
                      trigger="click"
                      onClick={() => fetchReservationServices(reservation.id, setLoading)}
                      color="#FFFFFF"
                      title={
                        <Fragment>
                          <Row justify="space-between">
                            <Col lg={12}>
                              <p className="title mb-10">
                                {t('reservations.byFilters.confirmedReservationTab.serviceTooltip')}
                              </p>
                            </Col>
                            <Col lg={6}>
                              <p className="title text-center mb-10">
                                {t('reservations.byFilters.confirmedReservationTab.workersTooltip')}
                              </p>
                            </Col>
                            <Col lg={6}>
                              <p className="title text-center mb-10">
                                {t('reservations.byFilters.confirmedReservationTab.blockTooltip')}
                              </p>
                            </Col>
                          </Row>
                          {
                            (
                              loading
                              && <Row justify="center">
                                <Spin className="cmt-spin" />
                              </Row>
                            )
                            || (
                              reservationServices?.map((service) => {
                                return (
                                  <Row justify="space-between" key={service.id}>
                                    <Col lg={12}>
                                      <p>{service.name}</p>
                                    </Col>
                                    <Col lg={6}>
                                      <p className="text-center">
                                        {service.total_patients}
                                      </p>
                                    </Col>
                                    <Col lg={6}>
                                      <p className="text-center">
                                        {service.block}hs
                                      </p>
                                    </Col>
                                  </Row>
                                );
                              })
                            )}
                        </Fragment>
                      }
                    >
                      <p className="mobile-title text-center">
                        {t('reservations.byFilters.confirmedReservationTab.servicesTitle')}
                      </p>
                      <p
                        className="text-center mb-0"
                        style={{ cursor: "pointer" }}
                      >
                        {t('reservations.byFilters.confirmedReservationTab.seeServicesButton')}
                      </p>
                    </Tooltip>
                  </Col>
                  <Col lg={3} xs={12} className="table-body__item-confirmed">
                    <Tooltip
                      overlayClassName='see-services-tooltip'
                      onClick={() => fetchReservationPatients(reservation.id, setLoading)}
                      trigger="click"
                      color="#FFFFFF"
                      title={
                        <Fragment>
                          {
                            (
                              loading
                              && <Row justify="center">
                                <Spin className="custom-spinner" />
                              </Row>
                            )
                            || (
                              (!reservationPatients || reservationPatients.length === 0)
                              && <p className="title text-center mb-0">
                                {t('reservations.byFilters.confirmedReservationTab.noPreAdmissionText')}
                              </p>
                            )
                            || (
                              reservationPatients?.map(
                                (patient, index) => {
                                  return (
                                    <Row justify="space-between" key={patient.id}>
                                      <Col lg={15}>
                                        <p>
                                          {patient.full_name
                                            ? patient.full_name
                                            : `${t('reservations.byFilters.confirmedReservationTab.patient')} ${index + 1}`}
                                        </p>
                                      </Col>
                                      <Col lg={9}>
                                        <p className="text-center">
                                          {patient.document_type === 'rut' ? format(patient.document_number) : patient.document_number}
                                        </p>
                                      </Col>
                                    </Row>
                                  );
                                }
                              )
                            )}
                        </Fragment>
                      }
                    >
                      <p className="mobile-title text-center">
                        {t('reservations.byFilters.confirmedReservationTab.patientsTitle')}
                      </p>
                      <p
                        className={`${!reservation.patients && 'disabled'} text-center mb-0`}
                        style={{ cursor: "pointer" }}
                      >
                        Ver trabajadores
                      </p>
                    </Tooltip>
                  </Col>
                  <Col
                    lg={2}
                    xs={24}
                    className="table-body__item button-wrapper"
                  >
                    <Link
                      to={{
                        pathname: `/reservas/${reservation.id}/ver`,
                        state: {
                          from: location.pathname,
                          search: location.search,
                        },
                      }}
                    >
                      <Button
                        id="seeMore"
                        className="cmt-button secondary outline mr-lg-15"
                        type="primary"
                        size="small"
                      >
                        Ver más
                      </Button>
                    </Link>
                  </Col>
                </Row>
              );
            })}
          </Col>
          <Col lg={22}>
            {confirmedReservations?.data && confirmedReservations?.pagination && (
              <Row className="mb-50">
                <Col>
                  <Radio.Group className="cmt-pagination">
                    <Radio.Button
                      value="prev"
                      disabled={
                        confirmedReservations.pagination.currentPage === '1' ||
                        confirmedReservations.pagination.lastPage === 1
                      }
                      onClick={loadMore}
                    >
                      Anterior
                    </Radio.Button>
                    <Radio.Button
                      value="next"
                      disabled={
                        confirmedReservations.data.length <
                        confirmedReservations.pagination.perPage ||
                        confirmedReservations.pagination.lastPage.toString() === confirmedReservations.pagination.currentPage
                      }
                      onClick={loadMore}
                    >
                      Siguiente
                    </Radio.Button>
                  </Radio.Group>
                </Col>
                <Col
                  className="ml-20"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                />
              </Row>
            )}
          </Col>
        </Fragment>
      ) : (
        <Empty
          description={
            <span style={{ fontSize: 12 }}>
              {t('reservations.byFilters.confirmedReservationTab.emptyReservations')}
            </span>
          }
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
      )}
    </Row>
  );
};

export default ConfirmedReservation;